import './beckman/style';
import FormStructure from './beckman/form_structure';

export default FormStructure;